import { useState } from "react";
import { CustomEventType } from "../constants/customEvent";
import useDispatchCustomEvent from "./useDispatchCustomEvent";
import useListenCustomEvent from "./useListenCustomEvent";

const useGlobalSound = () => {
  const [muted, setMuted] = useState(localStorage.getItem("mute") === "true");

  const dispatchCustomEvent = useDispatchCustomEvent();

  const toggleMute = () => {
    const muted = localStorage.getItem("mute") === "true";

    localStorage.setItem("mute", muted ? "false" : "true");

    setMuted(!muted);

    dispatchCustomEvent(CustomEventType.Mute, !muted);
  };

  useListenCustomEvent(CustomEventType.Mute, (event: Event) => {
    setMuted((event as CustomEvent).detail);
  });

  return { muted, toggleMute };
};

export default useGlobalSound;
